import React from 'react';
import { Typography, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {
        fontSize: '11px',
        lineHeight: '16px',
        color: theme.palette.KenColors.neutral400,
        textTransform:'uppercase',
        opacity:0.5
    },
    optional: {
        fontSize: '12px',
        lineHeight: '16px',
        color: theme.palette.KenColors.neutral100,
    },
    labelWrap: {
        marginBottom: 2
    },
}))
export default function KenTextLabel(props) {
    const classes = useStyles();
    const {
        label,
        required,
        optionalLabel,
    } = props;

    return (<div className={classes.labelWrap}>
        <Grid container justify="space-between" data-testid="label">
            <Grid item>
                <Typography className={classes.label}>{label}</Typography>
            </Grid>
            <Grid item>
                <Typography className={classes.optional}>{!required && optionalLabel ? 'Optional' : ' '}</Typography>
            </Grid>
        </Grid>
    </div>

    )
}